import { type ChangeEvent, type FC } from "react";

import classNames from "classnames";

import { RadioButton } from "@jti/core-components";
import type { ICurrencyEnum } from "@jti/magento";
import { type GetEligibleCampaignsResponseType } from "@jti/rest-api-types";
import { FormattedPrice, useTranslations } from "@jti/ui";

import styles from "./LoyaltyPointsDiscountsList.module.scss";

type LoyaltyPointsDiscountsListProps = {
  currency: ICurrencyEnum;
  vouchers: GetEligibleCampaignsResponseType[];
  loyaltyCampaignId: string;
  isLoyaltyError: boolean;
  handleCampaignChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const LoyaltyPointsDiscountsList: FC<LoyaltyPointsDiscountsListProps> = ({
  currency,
  vouchers,
  loyaltyCampaignId,
  isLoyaltyError,
  handleCampaignChange,
}) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.list}>
      {vouchers.map((item, index) => {
        const isDisabled = !item.is_eligible;
        const isChecked = loyaltyCampaignId === item.campaign_id;

        return (
          <div
            key={item.campaign_id}
            className={classNames(styles.radioItem, {
              [styles.radioItemChecked]: isChecked,
              [styles.radioItemError]: isLoyaltyError && !isDisabled,
              [styles.radioItemDisabled]: isDisabled,
            })}
            data-testid={`redeemLabel_${index}`}
          >
            <RadioButton
              value={item.campaign_id}
              name={item.campaign_id}
              checked={isChecked}
              disabled={isDisabled}
              isError={isLoyaltyError && !isDisabled}
              onChange={handleCampaignChange}
              label={
                <div className={styles.label}>
                  <span className={styles.pointsPrice} data-testid={`redeemPrice_${index}`}>
                    <FormattedPrice currency={currency} value={item.price} />
                  </span>
                  <span className={styles.pointsValue}>{__("loyalty.checkout.pointsCost", [item.points])}</span>
                </div>
              }
              data-testid={`redeemInput_${index}`}
            />
          </div>
        );
      })}
    </div>
  );
};
